module.exports = __webpack_public_path__ + "media/images/symbols/diagonal-arrow-1df73266fd2577ae2f026859a4cd21b3.svg";